import CreateTagModal from './CreateTagModal';

export default CreateTagModal;
